// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ConfirmationModal-cls1___b04ae05ad89e67dfe8f{/*!*/}.ConfirmationModal-cls2___bea254a813abedd60b6{margin-bottom:16px;min-height:64px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ConfirmationModal-cls1___b04ae05ad89e67dfe8f",
	"cls2": "ConfirmationModal-cls2___bea254a813abedd60b6 ConfirmationModal-cls1___b04ae05ad89e67dfe8f"
};
export default ___CSS_LOADER_EXPORT___;
